import { StackYouTubeVariant, StackYouTubePlayerProps } from '../../StackYouTubePlayer/StackYouTubePlayer';
import { ContentfulYouTube } from '@jbhi-fi/apis/src/contentful/types';
import { AssetTransformer } from './AssetTransformer';
import { buildContentfulApiImgSrc } from '../../ContentfulImage/buildContentfulApiImgSrc';

export abstract class YouTubeTransformer {
  static toYouTubePlayerProps = (
    { fields }: ContentfulYouTube,
    variant: StackYouTubeVariant = 'default'
  ): StackYouTubePlayerProps => {
    return {
      videoUrl: fields?.url,
      landscapeThumbnailUrl: fields?.landscapeCoverImage
        ? buildContentfulApiImgSrc(AssetTransformer.toImageProps(fields?.landscapeCoverImage)?.src || '')
        : undefined,
      portraitThumbnailUrl: fields?.portraitCoverImage
        ? buildContentfulApiImgSrc(AssetTransformer.toImageProps(fields?.portraitCoverImage)?.src || '')
        : undefined,
      variant: variant,
    };
  };
}
